// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-comment {
  /* Border */
  --perxis-auto-comment-border-width-inner: var(--perxis-auto-comment-border-width, 1px);
  --perxis-auto-comment-border-radius-inner: var(--perxis-auto-comment-border-radius, 18px);
  --perxis-auto-comment-border-color-inner: var(--perxis-auto-comment-border-color, var(--perxis-auto-root-ninth-color-inner));
  /* End Border */
  /* Gap */
  --perxis-auto-comment-title-gap-inner: var(--perxis-auto-comment-title-gap, var(--perxis-auto-gap-vertical-yellow-inner));
  --perxis-auto-comment-body-gap-inner: var(--perxis-auto-comment-body-gap, var(--perxis-auto-gap-vertical-green-inner));
  /* End Gap */
  padding: var(--perxis-auto-comment-body-gap-inner);
  border-radius: var(--perxis-auto-comment-border-radius-inner);
  border-width: var(--perxis-auto-comment-border-width-inner);
  border-color: var(--perxis-auto-comment-border-color-inner);
  border-style: solid;
  display: flex;
  flex-direction: column;
  gap: var(--perxis-auto-comment-title-gap-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
